import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
import { MUTATE } from '@/store/modules/mutation_types';
import Cookies from 'js-cookie';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

export const PAGES_ERROR_TYPES = {
  SERVER_ERROR: '500',
  MISSED_ACCOUNT_AND_UNIVERSE: '405',
  DASHBOARD_NOT_FOUND: '406',
};

export const getErrorPage = (errorStatus = PAGES_ERROR_TYPES.SERVER_ERROR) => ({
  name: 'error',
  params: { errorStatus },
});

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/shopping2022',
      beforeEnter(to, from, next) {
        Cookies.set('dashboard-token', '100921639752007942');
        next({
          name: 'home',
          params: {
            accountId: '5653408454803456',
            universeId: '6275063761600512',
            dashboard: '8xhKkcXgbgaIbnEkIZqj',
          },
          query: {
            public: 1,
          },
        });
      },
    },
    {
      path: '/:accountId/:universeId/login/',
      name: 'login',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/LoginView.vue'),
    },
    {
      path: '/:accountId/:universeId/token/',
      name: 'token',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/TokenView.vue'),
    },
    {
      path: '/:accountId/:universeId/onboarding/',
      name: 'onboarding',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/Onboarding.vue'),
    },
    {
      path: '/:accountId/:universeId/dashboard/',
      name: 'home',
      props: true,
      component: () => import(/* webpackPrefetch: true */ './views/Home.vue'),
    },
    {
      path: '/error',
      alias: ['403', '500'],
      name: 'error',
      component: () => import(/* webpackPrefetch: true */ './views/ErrorPageWrapper.vue'),
      props: true,
    },
    {
      path: '/',
      redirect: () => {
        const hasSessionId = Boolean(Cookies.get('stilingue-session-id'));
        const accountId = Cookies.get('acc_id')?.split('|')[0];
        const universeId = Cookies.get('uni_id')?.split('|')[0];

        if (hasSessionId && accountId && universeId) {
          return `${accountId}/${universeId}/dashboard`;
        }

        location.href = process.env.VUE_APP_WARROOM_URL;
      },
    },
    {
      path: '*',
      redirect: 'error',
      props: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit(`misc/${MUTATE}`, {
    property: 'hasInitialData',
    with: false,
  });
  next();
});

router.afterEach(() => {
  store.commit(`misc/${MUTATE}`, {
    property: 'hasInitialData',
    with: true,
  });
});

export default router;
